var AbstractView = require("common/AbstractView");

/**
 * View used for TOTP portal, has a message saying to use the settings menu option
 *
 * @constructor
 * @extends {AbstractView}
 */
function MainTOTPView() {
    const $content = $(require("html!./main_totp_view.html"));

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "TOTPMain";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("common::totp.title"),
            i18n : "common::totp.title"
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "totp";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.requiresAuthentication = function() {
        return true;
    };
}

MainTOTPView.prototype = AbstractView;

module.exports = MainTOTPView;